/* eslint-disable prettier/prettier */
import { createContext, ReactNode, useContext } from 'react';
import type { MIStore } from './MIStore';

interface MIContextValue {
  store: MIStore;
  handleGetMI: (args: {
    rateDataID: number;
    programID: number;
    rateData?: any;
    displayEstimatedMI?: string;
    selectedMiType: string;
  }) => Promise<void>;
}

const MIContext = createContext<MIContextValue | null>(null);

interface MIProviderProps {
  value: MIContextValue;
  children: ReactNode;
}

export const MIProvider = ({ value, children }: MIProviderProps) => (
  <MIContext.Provider value={value}>{children}</MIContext.Provider>
);

export const useMIContext = () => {
  const ctx = useContext(MIContext);
  if (!ctx) throw new Error('useMIContext must be used within MIProvider');
  return ctx;
};
